import { render } from "./TaskSettingsModal.vue?vue&type=template&id=64c15968&scoped=true"
import script from "./TaskSettingsModal.vue?vue&type=script&lang=js"
export * from "./TaskSettingsModal.vue?vue&type=script&lang=js"

import "./TaskSettingsModal.vue?vue&type=style&index=0&id=64c15968&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64c15968"

export default script